import { useContext } from "react";
import { AgenticLogicSurface } from "@src/features/ai/pages/agentic-logic/surface/surface";
import { AgenticLogicSurfaceContext } from "@src/features/ai/pages/agentic-logic/surface/context";

export const useAgenticLogicSurface = (): AgenticLogicSurface => {
  const surface = useContext(AgenticLogicSurfaceContext);
  if (!surface) {
    throw new Error(
      "useAgenticLogicSurface must be used inside an AgenticLogicSurfaceProvider"
    );
  }
  return surface;
};
